import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-minus\">\n<path fill-rule=\"evenodd\" d=\"M-0.000,-0.000 L10.000,-0.000 L10.000,2.000 L-0.000,2.000 L-0.000,-0.000 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol